import React, { ReactNode } from "react";
import classNames from "classnames";
import Button, { VariantTypes, SizeTypes } from "./Button";

interface ButtonTabItem<TValue extends string = string> {
    text: ReactNode;
    key: TValue
}
export default function ButtonTabs<TValue extends string = string>({
    values,
    onChange,
    value,
    isDisabled,
    className,
    variant,
    size,
    tabVariant,
}: {
    values : ButtonTabItem<TValue>[]
    onChange: (item: ButtonTabItem<TValue>) => void;
    value: TValue;
    isDisabled?: boolean;
    className?: string;
    variant?: VariantTypes;
    size?: SizeTypes;
    tabVariant?: "default" | "tabs"
}) {
    return (
        <div className={classNames(tabVariant === "tabs" ? "btn-list-tabs" : "btn-list", className)}>
            {values.map(item => (
                <Button
                    size={size}
                    variant={variant}
                    isActive={value === item.key}
                    onClick={() => onChange(item)}
                    disabled={isDisabled}
                >
                    {item.text}
                </Button>
            ))}
        </div>
    );
}

ButtonTabs.defaultProps = {
    isDisabled: false,
    className: undefined,
    variant: "none",
    size: "small",
    tabVariant: "default",
};
